import Vue from 'vue';

import ErrorList from '@/components/ErrorList';
import PageContainer from '@/components/PageContainer';
import PageLoading from '@/components/PageLoading';

Vue.component('error-list', ErrorList);
Vue.component('page-container', PageContainer);
Vue.component('page-loading', PageLoading);
